import {CurrentUser} from "@/services/ant-design-pro/type"

export default function access(
  initialState: { currentUser?: CurrentUser } | undefined,
) {
  const {currentUser} = initialState ?? {};
  return {
    admin: currentUser && (currentUser.isAdmin === 1 || currentUser.isAdmin === 2),
  };
}
